import React from "react";
import ReactQuill from "react-quill"; // import ReactQuill
import "react-quill/dist/quill.snow.css"; // import styles
import styles from "./RichTextEditor.module.css";
import { Label } from "../Inputs/ShortTextInput";

// RichTextEditor Component
const RichTextEditor = ({
  editorValue,
  setEditorValue,
  className,
  label,
  helperText,
  error,
  id,
  required,
}) => {
  const handleChange = (value) => {
    setEditorValue(value);
  };

  return (
    <>
      {label && <Label id={id} required={required} label={label}  />}
      <div className={`${styles.container} ${error ? styles.error : ""}`}>
        <ReactQuill
          id={id}
          value={editorValue}
          onChange={handleChange}
          className={`w-100 ${className}`}
          modules={{
            toolbar: [
              [{ header: "1" }, { header: "2" }, { font: [] }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ indent: "-1" }, { indent: "+1" }],
              [{ align: [] }],
              ["bold", "italic", "underline"],
              ["link"],
              ["image"],
              ["blockquote"],
              ["code-block"],
            ],
          }}
        />
      </div>
      {/* Helper Text */}
      {(helperText || error) && (
        <p
          id={`${id}-helper-text`}
          className={styles.helperText}
          style={{
            color: error ? "#d32f2f" : "inherit",
          }}
        >
          {error || helperText}
        </p>
      )}
    </>
  );
};

export default RichTextEditor;

//* to use this
// import RichTextEditor from "./RichTextEditor";
// const [editorValue, setEditorValue] = useState("");
// <RichTextEditor editorValue={editorValue} setEditorValue={setEditorValue} />
